import preferenceKeys from '../person-page/preference-keys'
import useCachedFeatureFlagWithPrefs from './useCachedFeatureFlagWithPrefs'

export default function useQualityIndicatorFlag(): ReturnType<typeof useCachedFeatureFlagWithPrefs> {
  return useCachedFeatureFlagWithPrefs('treeWeb_personR9_qualityIndicator', preferenceKeys.QUALITY_INDICATOR, {
    userPreferences: ['fslabs.labs'],
  })
}
